import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { THEME_MODES } from '../../settings/constants';
import logger from '../logger';
import { getThemeByMode } from '../themes.web';
/** 系统深色偏好媒体查询（与 matchMedia 配合解析「跟随系统」）。. */
const PREFERS_DARK_QUERY = '(prefers-color-scheme: dark)';
/**
 * The theme provider for the web app.
 *
 * @param {Object} props - The props of the component.
 * @returns {React.ReactElement}
 */
function JitsiThemeProvider(props) {
    const [systemDark, setSystemDark] = useState(() => window.matchMedia(PREFERS_DARK_QUERY).matches);
    const prevEffectiveRef = useRef();
    // 监听系统深浅色偏好变化，「跟随系统」时实时联动。
    useEffect(() => {
        const media = window.matchMedia(PREFERS_DARK_QUERY);
        const onSystemThemeChange = (event) => {
            logger.info(`[主题] ${new Date().toISOString()} 系统主题变化 systemDark=${event.matches}`);
            setSystemDark(event.matches);
        };
        media.addEventListener('change', onSystemThemeChange);
        return () => media.removeEventListener('change', onSystemThemeChange);
    }, []);
    const effectiveMode = props._themeMode === THEME_MODES.SYSTEM
        ? (systemDark ? 'dark' : 'light')
        : props._themeMode;
    // 主题生效值变化时：写 DOM 标记（供 SCSS 选用）+ 中文日志。
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', effectiveMode);
        document.documentElement.style.colorScheme = effectiveMode;
        if (prevEffectiveRef.current !== effectiveMode) {
            logger.info(`[主题] ${new Date().toISOString()} 生效主题变更`
                + ` themeMode=${props._themeMode} systemDark=${systemDark} effective=${effectiveMode}`);
            prevEffectiveRef.current = effectiveMode;
        }
    }, [effectiveMode, props._themeMode, systemDark]);
    const theme = props._brandedTheme || getThemeByMode(effectiveMode);
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(ThemeProvider, { theme: theme }, props.children)));
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { muiBrandedTheme } = state['features/dynamic-branding'];
    return {
        _brandedTheme: muiBrandedTheme,
        _themeMode: state['features/base/settings'].themeMode ?? THEME_MODES.SYSTEM
    };
}
export default connect(_mapStateToProps)(JitsiThemeProvider);
